import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .EDText': {
    color: theme.palette.text.secondary,
    '& p': {
      margin: 0,
    },
  },
  '& .EDExpandBtn': {
    paddingLeft: 0,
    textTransform: 'capitalize',
    color: theme.palette.common.white,
    fontWeight: 700,
    '& p:first-of-type': {
      marginTop: 0,
    },
  },
  '& a': {
    color: theme.palette.common.white,
    fontWeight: 700,
  },
  '& .EDArrowIcon': {
    color: theme.palette.common.white,
  },
}));

export default StyledBox;
